import requests from "./request";
 
//用户信息-添加
export const adminCustomerInfoAdd = (data) => {
  return requests({ url: "/admin/account/customer/info/", method: "post", data });
};
//产品列表
export const adminProductInfo = (data) => {
  return requests({ url: "/admin/product/info/?page="+data.page+'&page_size='+data.page_size, method: "get", data });
};
//配置中心
export const adminConfigInfo= (data) => {
  return requests({ url: "/admin/config/info/", method: "get", data });
}



// WEBPACK FOOTER //
// ./src/request/api.js